import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  levelIndex: 0, // 0-based index
  hasOnboarded: false,
};

const roundReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        hasOnboarded: true,
      };

    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelIndex: payload,
      };

    default:
      return state;
  }
};

export default roundReducer;
